/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon20Light = forwardRef('MediaUiAPlayForwardIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4 3.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0v-13Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.7 3.185a1.1 1.1 0 0 0-1.7.922v11.786a1.1 1.1 0 0 0 1.7.922l8.793-5.726a1.3 1.3 0 0 0 0-2.178L8.7 3.185Zm-.7.922a.1.1 0 0 1 .155-.084l8.793 5.726a.3.3 0 0 1 0 .502l-8.793 5.726A.1.1 0 0 1 8 15.893V4.107Z" })));
});
